import React from "react";

import { WebgeoLogo } from "../../../../shared/assets/logos";
import { Container } from "./style";
import prefeituraLogo from "../../../../shared/assets/logos/clients/palmeira/logos/prefeitura_municipal.png";
import secretariaUrbanismoLogo from "../../../../shared/assets/logos/clients/palmeira/logos/secretaria_urbanismo.jpeg";

export const HeaderPalmeira: React.FC = () => {
    const PrefeituraLogo = prefeituraLogo;
    const SecretariaUrbanismoLogo = secretariaUrbanismoLogo;
    return (
        <Container>
            {/* <LeftHeader>
                <div style={{ width: "100px" }}>
                    <img src={ClientLogo} alt="logo cidade" />
                </div>
            </LeftHeader>
            <div style={{ width: "200px" }}>
                <img
                    src="/palmeira/logos/secretaria_urbanismo.JPG"
                    alt="Brasão de Palmeira com a escrita indicando Município de PALMEIRA Secretaria de Urbanismo"
                />
            </div> */}
            <section style={{ width: "200px" }}>
                <img src={PrefeituraLogo} alt="logo prefeitura da cidade" />
            </section>
            <section style={{ width: "200px" }}>
                <img
                    src={SecretariaUrbanismoLogo}
                    alt="Brasão de Palmeira com a escrita indicando Município de PALMEIRA Secretaria de Urbanismo"
                />
            </section>
            <section style={{ width: "200px" }}>
                <img src={WebgeoLogo} alt="logo webgeo" />
            </section>
        </Container>
    );
};
